import React from 'react';
import { Section } from './Section';
import { Button } from './Button';
import { ShieldCheck, Zap, FileText } from 'lucide-react';
export function FinalOfferSection() {
  return <Section id="offer" className="bg-sage pb-24" data-id="element-33">
      <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border-2 border-gold max-w-3xl mx-auto text-center relative overflow-hidden" data-id="element-34">
        <div className="absolute top-0 right-0 w-32 h-32 bg-gold opacity-10 rounded-bl-full" data-id="element-35"></div>
        <div className="absolute bottom-0 left-0 w-32 h-32 bg-forest opacity-5 rounded-tr-full" data-id="element-36"></div>

        <h2 className="font-serif text-3xl md:text-4xl text-forest font-bold mb-6 relative z-10" data-id="element-37">
          Empieza hoy tu Protocolo Anti-Inflamación 72H
        </h2>
        <p className="text-gray-600 text-lg mb-8 relative z-10" data-id="element-38">
          Accede ahora a tu guía digital en PDF y empieza hoy mismo con un plan
          simple para sentirte más ligera, menos hinchada y más cómoda en tu
          cuerpo.
        </p>

        <img src="https://cdn.magicpatterns.com/uploads/u3h6xU6zEcqbpUAvD2WZDQ/Mockup_PTO_1_Anti-Desinflamacion_72H.png" alt="Protocolo Anti-Inflamación 72h" className="w-64 md:w-80 mx-auto mb-8 relative z-10 drop-shadow-xl" data-id="element-39" />

        <div id="offer-price" className="bg-cream p-6 rounded-2xl mb-8 border border-sage-dark relative z-10" data-id="element-40">
          <p className="text-forest font-medium mb-3" data-id="element-41">Hoy por solo</p>
          <div className="inline-block bg-red-500 text-white font-bold text-sm md:text-base px-4 py-1.5 rounded-full mb-4 animate-pulse shadow-md" data-id="element-42">
            🔥 DESCUENTO DEL 68% — OFERTA LIMITADA
          </div>
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-43">
            <span className="text-2xl md:text-3xl text-gray-400 line-through font-serif" data-id="element-44">
              Antes $19.99 USD
            </span>
          </div>
          <div className="text-5xl md:text-6xl font-bold text-forest font-serif mb-2" data-id="element-45">
            $6.39 <span className="text-2xl text-gray-500" data-id="element-46">USD</span>
          </div>
        </div>

        <Button className="w-full md:w-auto text-xl py-5 px-10 mb-6 relative z-10" data-id="element-47">
          SÍ, QUIERO DESINFLAMARME AHORA
        </Button>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm text-gray-500 relative z-10" data-id="element-48">
          <div className="flex items-center gap-2" data-id="element-49">
            <Zap className="w-5 h-5 text-gold" data-id="element-50" />
            <span data-id="element-51">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-52">
            <ShieldCheck className="w-5 h-5 text-green-600" data-id="element-53" />
            <span data-id="element-54">Pago seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-55">
            <FileText className="w-5 h-5 text-forest-light" data-id="element-56" />
            <span data-id="element-57">Formato digital en español</span>
          </div>
        </div>
      </div>
    </Section>;
}